import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Table,
	Statistic,
	notification,
	Row,
	Col,
	Button,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSearch, CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { franchises57ClientsOptions } from "../../constants/Customer";
import { getAggregateCogsCost } from "../utils/CogCost";

const { Text } = Typography;

const SalesBySellerReport = () => {
	const [loading, setLoading] = useState(false);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [list, setList] = useState([]);
	const [list2, setList2] = useState([]);
	const [franchise, setFranchise] = useState("57Concrete");
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalPrice",
			key: "totalPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average of Sales Price $",
			dataIndex: "averageSalesPrice",
			key: "averageSalesPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average of Total COGS",
			dataIndex: "averageCogs",
			key: "averageCogs",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average of Total GROSS/CY",
			dataIndex: "averageGross",
			key: "averageGross",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Total GROSS",
			dataIndex: "totalGross",
			key: "totalGross",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Commission",
			dataIndex: "commission",
			key: "commission",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Seller Payout",
			dataIndex: "sellerPayout",
			key: "sellerPayout",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
	];

	const columns2 = [
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalPrice",
			key: "totalPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average of Sales Price $",
			dataIndex: "averageSalesPrice",
			key: "averageSalesPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average of Total COGS",
			dataIndex: "averageCogs",
			key: "averageCogs",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average of Total GROSS/CY",
			dataIndex: "averageGross",
			key: "averageGross",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Total GROSS",
			dataIndex: "totalGross",
			key: "totalGross",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Commission By Plant",
			dataIndex: "commission",
			key: "commission",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Seller Payout",
			dataIndex: "sellerPayout",
			key: "sellerPayout",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
	];

	const columns3 = [
		{
			title: "Psi",
			dataIndex: "psi",
			key: "psi",
			width: 250,
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Total CY",
			dataIndex: "totalYards",
			key: "totalYards",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Total $",
			dataIndex: "totalPrice",
			key: "totalPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average of Sales Price $",
			dataIndex: "averageSalesPrice",
			key: "averageSalesPrice",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average of Total COGS",
			dataIndex: "averageCogs",
			key: "averageCogs",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Average of Total GROSS/CY",
			dataIndex: "averageGross",
			key: "averageGross",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Total GROSS",
			dataIndex: "totalGross",
			key: "totalGross",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Commission",
			dataIndex: "commission",
			key: "commission",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
		{
			title: "Seller Payout",
			dataIndex: "sellerPayout",
			key: "sellerPayout",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={2}
						valueStyle={{ fontSize: 14 }}
						prefix={"$"}
					/>
				);
			},
		},
	];

	const expandedRowRender = (row) => {
		const expandedRowRender2 = (row2) => {
			return (
				<Table columns={columns3} dataSource={row2.psis} pagination={false} />
			);
		};

		return (
			<Table
				columns={columns2}
				dataSource={row.plantRows}
				pagination={false}
				expandable={{
					expandedRowRender: expandedRowRender2,
				}}
				onRow={(record) => ({
					style: {
						background: "#8b91a3ff",
					},
				})}
			/>
		);
	};

	useEffect(() => {
		getLogisticsList();
	}, [startDate, endDate, franchise]);

	const getLogisticsList = async () => {
		setLoading(true);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/job/get/salesbyseller/${"All"}/${franchise}?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);

			if (data.success) {
				let list = [];

				const groupedSeller = data.payload.reduce((acc, item) => {
					if (!acc[`${item.seller._id}_${item.seller.name}`]) {
						acc[`${item.seller._id}_${item.seller.name}`] = [];
					}
					acc[`${item.seller._id}_${item.seller.name}`].push(item);
					return acc;
				}, {});

				Object.entries(groupedSeller).map(([key, jobs]) => {
					const groupedSellerByPlant = jobs.reduce((acc, item) => {
						if (!acc[`${item.plant._id}_${item.plant.name}`]) {
							acc[`${item.plant._id}_${item.plant.name}`] = [];
						}
						acc[`${item.plant._id}_${item.plant.name}`].push(item);
						return acc;
					}, {});

					let plantRows = [];
					Object.entries(groupedSellerByPlant).map(
						([keySellerPlant, plantJobs]) => {
							let psis = [];
							const groupedSellerByPlantPsi = plantJobs
								.filter((i) => i.psiId !== null && i.psiId !== undefined)
								.reduce((acc, item) => {
									if (!acc[`${item.psiId._id}_${item.psiId.psi}`]) {
										acc[`${item.psiId._id}_${item.psiId.psi}`] = [];
									}
									acc[`${item.psiId._id}_${item.psiId.psi}`].push(item);
									return acc;
								}, {});

							Object.entries(groupedSellerByPlantPsi).map(
								([keyPsi, psiJobs]) => {
									let totalYardsPlantPsi = 0;
									let totalPricePlantPsi = 0;
									let averageSalesPricePlantPsi = 0;
									let averageCogsPlantPsi = 0;
									// let totalGrossPlantPsi = 0;
									let commissionPlantPsi = 0;
									let sellerPayoutPlantPsi = 0;
									psiJobs.map((jobItem, jobIndex) => {
										totalYardsPlantPsi += jobItem.loadYD3;
										totalPricePlantPsi += jobItem.loadYD3 * jobItem.unitPrice;
										// averageSalesPricePlantPsi += jobItem.unitPrice;
										const cogs = getAggregateCogsCost(jobItem.aggregate);

										averageCogsPlantPsi += cogs;

										// totalGrossPlantPsi +=
										// 	(jobItem.unitPrice - cogs) * jobItem.loadYD3;

										const c = jobItem.psiId
											? jobItem.psiId.plants?.find(
													(i) => i.plant === jobItem.plant._id
											  )?.commission ?? 0
											: 0;
										commissionPlantPsi += c;
										sellerPayoutPlantPsi += c * jobItem.loadYD3;
									});
									averageSalesPricePlantPsi =
										totalPricePlantPsi / totalYardsPlantPsi;
									// averageSalesPricePlantPsi =
									// 	averageSalesPricePlantPsi / psiJobs.length;
									averageCogsPlantPsi = averageCogsPlantPsi / psiJobs.length;
									let averageGrossPlantPsi =
										averageSalesPricePlantPsi - averageCogsPlantPsi;

									psis.push({
										index: keyPsi.split("_")[0],
										key: keyPsi.split("_")[0],
										psi: keyPsi.split("_")[1],
										totalYards: totalYardsPlantPsi,
										totalPrice: totalPricePlantPsi,
										averageCogs: averageCogsPlantPsi,
										averageGross: averageGrossPlantPsi,
										totalGross: totalYardsPlantPsi * averageGrossPlantPsi,
										// totalGross: totalGrossPlantPsi,
										commission: commissionPlantPsi || 0,
										sellerPayout: sellerPayoutPlantPsi,
										averageSalesPrice: averageSalesPricePlantPsi,
									});
								}
							);

							let totalYardsPlant = 0;
							let totalPricePlant = 0;
							let averageSalesPricePlant = 0;
							let averageCogsPlant = 0;
							let totalGrossPlant = 0;
							let commissionPlant = 0;
							let sellerPayoutPlant = 0;
							plantJobs.map((jobItem, jobIndex) => {
								totalYardsPlant += jobItem.loadYD3;
								totalPricePlant += jobItem.loadYD3 * jobItem.unitPrice;
								averageSalesPricePlant += jobItem.unitPrice;

								const cogs = getAggregateCogsCost(jobItem.aggregate);

								averageCogsPlant += cogs;

								totalGrossPlant += (jobItem.unitPrice - cogs) * jobItem.loadYD3;

								const c = jobItem.psiId
									? jobItem.psiId.plants?.find(
											(i) => i.plant === jobItem.plant._id
									  )?.commission ?? 0
									: 0;
								commissionPlant += c;
								sellerPayoutPlant += c * jobItem.loadYD3;
							});
							averageSalesPricePlant =
								averageSalesPricePlant / plantJobs.length;
							averageCogsPlant = averageCogsPlant / plantJobs.length;
							let averageGrossPlant = averageSalesPricePlant - averageCogsPlant;

							plantRows.push({
								index: keySellerPlant.split("_")[0],
								key: keySellerPlant.split("_")[0],
								plant: keySellerPlant.split("_")[1],
								totalYards: totalYardsPlant,
								totalPrice: totalPricePlant,
								averageSalesPrice: averageSalesPricePlant,
								averageCogs: averageCogsPlant,
								averageGross: averageGrossPlant,
								totalGross: totalGrossPlant,
								commission: commissionPlant || 0,
								sellerPayout: sellerPayoutPlant,
								psis: psis,
							});
						}
					);

					let totalYards = 0;
					let totalPrice = 0;
					let averageSalesPrice = 0;
					let averageCogs = 0;
					let totalGross = 0;
					let commission = 0;
					let sellerPayout = 0;
					jobs.map((jobItem, jobIndex) => {
						totalYards += jobItem.loadYD3;
						totalPrice += jobItem.loadYD3 * jobItem.unitPrice;
						averageSalesPrice += jobItem.unitPrice;

						const cogs = getAggregateCogsCost(jobItem.aggregate);

						averageCogs += cogs;

						totalGross += (jobItem.unitPrice - cogs) * jobItem.loadYD3;

						const c = jobItem.psiId
							? jobItem.psiId.plants?.find((i) => i.plant === jobItem.plant._id)
									?.commission ?? 0
							: 0;
						commission += c;
						sellerPayout += c * jobItem.loadYD3;
					});
					averageSalesPrice = averageSalesPrice / jobs.length;
					averageCogs = averageCogs / jobs.length;
					let averageGross = averageSalesPrice - averageCogs;

					list.push({
						key: key.split("_")[0],
						index: key.split("_")[0],
						seller: key.split("_")[1],
						totalYards,
						totalPrice,
						averageSalesPrice,
						averageCogs,
						averageGross,
						totalGross,
						commission: commission || 0,
						sellerPayout,
						plantRows,
					});
				});

				setList(list);

				let list2 = [];
				data.payload.map((item) => {
					const cogs = getAggregateCogsCost(item.aggregate);

					list2.push({
						seller: item.seller.name,
						plant: item.plant.name,
						mixDesign: item.psiId ? item.psiId.psi : item.psi,
						client: item.customer.name,
						totalYards: item.loadYD3,
						totalUnitPrice: item.unitPrice * item.loadYD3,
						salesPrice: item.unitPrice,
						totalCogs: cogs,
						grossYards: item.unitPrice - cogs,
						totaGross: (item.unitPrice - cogs) * item.loadYD3,
					});
				});
				setList2(list2);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", "Error while trying to get jobs");
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={columns}
					dataSource={list}
					expandable={{
						expandedRowRender,
					}}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [50, 100],
						defaultPageSize: 50,
						showSizeChanger: true,
					}}
					scroll={{
						x: "max-content",
					}}
					style={{
						minWidth: "100%",
					}}
					onRow={(record) => ({
						style: {
							background: "#7686bbff",
						},
					})}
				/>
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const onChangeFranchisePicker = (value) => {
		setFranchise(value);
	};

	const RenderDates = () => {
		return (
			<CustomSearch
				loading={loading}
				startDate={startDate}
				endDate={endDate}
				dateFormat={"MM/DD/YYYY"}
				onRangeChange={onRangeChange}
				onChangePicker={onChangeFranchisePicker}
				pickerValue={franchise}
				pickerWidth={"250px"}
				labelPicker={"Franchise"}
				disabledPicker={loading}
				optionsPicker={franchises57ClientsOptions}
			/>
		);
	};

	function getFlattenedHeaders(columns) {
		return columns.flatMap((col) => {
			const title = col.title;
			return title;
		});
	}

	function getFlattenedKeys(columns) {
		return columns.flatMap((col) => {
			return col.dataIndex || col.key || ""; // prefer dataIndex, fallback to key
		});
	}

	const handleExportXlsx = () => {
		// Step 1: Get headers
		let data = [];
		const headers = getFlattenedHeaders(columns);
		const keys = getFlattenedKeys(columns);
		const keysPlant = getFlattenedKeys(columns2);
		const keysPlantPsi = getFlattenedKeys(columns3);

		data.push(headers);

		list.map((item) => {
			let top = [];
			keys.map((i) => {
				top.push(item[i]);
			});
			data.push(top);

			let middle = [];
			item.plantRows.map((item2) => {
				keysPlant.map((j) => {
					middle.push(item2[j]);
				});
				data.push(middle);
				middle = [];

				let bottom = [];
				item2.psis.map((item3) => {
					keysPlantPsi.map((k) => {
						bottom.push(item3[k]);
					});
					data.push(bottom);
					bottom = [];
				});
			});

			data.push([]);
		});

		const ws = XLSX.utils.aoa_to_sheet(data);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "SALES per Seller");

		let data2 = [];
		data2.push([
			"Seller",
			"Plant",
			"Mix Design",
			"Clients",
			"Total CY",
			"Total $",
			"Sales Price $",
			"Total COGS",
			"GROSS/CY",
			"Total GROSS",
		]);
		list2.map((item) => {
			data2.push([
				item.seller,
				item.plant,
				item.mixDesign,
				item.client,
				item.totalYards,
				item.totalUnitPrice,
				item.salesPrice,
				item.totalCogs,
				item.grossYards,
				item.totaGross,
			]);
		});

		const ws2 = XLSX.utils.aoa_to_sheet(data2);
		XLSX.utils.book_append_sheet(wb, ws2, "Detailed Summary");

		// Step 4: Export file
		XLSX.writeFile(wb, `57 Sales Report By Seller.xlsx`);
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={handleExportXlsx}
							loading={loading}
							disabled={list.length === 0}
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<Layout title="Seller Report" description="Report" type="large">
			<Flex vertical gap={"large"}>
				<RenderDates />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
			{contextHolder}
		</Layout>
	);
};

export default SalesBySellerReport;
